import React from 'react'
import styled from 'styled-components'

import { color } from 'styles/colors'

type Props = {
  isEnabled: boolean
}

const StatusCell = ({ isEnabled }: Props) => {
  return (
    <S.Status isEnabled={isEnabled}>
      {isEnabled ? 'not published' : 'published'}
    </S.Status>
  )
}

const S = {
  Status: styled.div.withConfig({
    shouldForwardProp: (prop) => !['isEnabled'].includes(prop)
  }) <{ isEnabled: boolean }>`
    display: inline-block;
    padding: 4px 10px;
    margin-bottom: 5px;
    margin-right: 10px;
    text-align: center;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0;
    border: 1px solid ${color('border')};
    border-radius: 14px;

    ${({ isEnabled }) => `
      color: ${isEnabled ? color('statusDisabledText') : color('statusEnabledText')};
      background-color: ${isEnabled ? 'transparent' : color('positiveStatus')};
      border-color: ${isEnabled ? color('border') : color('StatusEnabledBorder')};
    `}
  `
}

export default StatusCell
